import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessagesService } from 'src/app/shared/services/messages/messages.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { Utility } from 'src/app/shared/utility';
import { UserService } from 'src/app/shared/services/common/user.service';
import { UsersService } from 'src/app/shared/services/common/users.service';

@Component({
  selector: 'app-view-message',
  templateUrl: './view-message.component.html',
  styleUrls: ['./view-message.component.css']
})
export class ViewMessageComponent implements OnInit {

  maxLength: any;
  setSubject: any;
  setTopic: any;
  origMsg: any;
  messageVal: any;
  reply: any;
  showReply = false;
  deletedMsg: any;
  @Input() msgData: any;
  @Output() closeModel: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateGrid: EventEmitter<any> = new EventEmitter<any>();
  @Input() inputData: any;

  constructor(
    private router: Router,
    private usersService: UsersService,
    private msgService: MessagesService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.setSubject = this.msgData.subject;
    this.setTopic = this.msgData.topic;
    this.origMsg = this.msgData.message;
    this.deletedMsg = this.msgData.deleted;
    this.maxLength = this.readConfigService.getSecuMessagesText().BodyMaxLength;
    if (this.msgData.receivedDt !== null && this.msgData.read !== true) {
      this.readMessage();
    }
    if (this.msgData.receivedDt !== null && this.msgData.parentId === 0) {
      this.showReply = true;
    }
  }

  sendMessage() {
    const data: any = { ...this.inputData };
    data.message = {
      topicId: this.msgData.topicId,
      subject: this.msgData.subject,
      message: this.usersService.encrypt(this.messageVal.trim(), 'post'),
      messageType: 'Secure Message',
      parentId: ''
    };
    this.msgService.sendMessage(data).subscribe((response: any) => {
      if (response && response.statusCode === 201) {
        this.closeModel.emit(response);
        this.notificationService.setUpNotification({ message: response.message, success: true });
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err.error);
        this.notificationService.setErrorNotification();
      });
  }

  readMessage() {
    this.msgService.readMessage(this.msgData.id).subscribe((data: any) => {
      if (data && data.statusCode === 200) {
        this.updateGrid.emit();
      } else {
        this.notificationService.setErrorNotification();
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err.error);
        this.notificationService.setErrorNotification();
      });
  }

  replyMessage() {
    this.reply = true;
  }

  isDisabled(): boolean {
    return !!this.messageVal;
  }
}
